'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlDomainSegment = require('./validateUrlDomainSegment');

var _validateUrlDomainSegment2 = _interopRequireDefault(_validateUrlDomainSegment);

var _validateUrlDomainTld = require('./validateUrlDomainTld');

var _validateUrlDomainTld2 = _interopRequireDefault(_validateUrlDomainTld);

var _validateUrlSubDomainSegment = require('./validateUrlSubDomainSegment');

var _validateUrlSubDomainSegment2 = _interopRequireDefault(_validateUrlSubDomainSegment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validateUrlDomain = (0, _regexSupplant2.default)(/(?:(?:#{validateUrlSubDomainSegment}\.)*(?:#{validateUrlDomainSegment}\.)#{validateUrlDomainTld})/i, {
  validateUrlSubDomainSegment: _validateUrlSubDomainSegment2.default,
  validateUrlDomainSegment: _validateUrlDomainSegment2.default,
  validateUrlDomainTld: _validateUrlDomainTld2.default
});

exports.default = validateUrlDomain;
module.exports = exports['default'];